import { Box, Button, Dialog, DialogActions, DialogContent, Link } from '@mui/material';
import { useContext, useState } from 'react';

import { DialogTitleWithClose } from '@/components/common/DialogTitleWithClose';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { SelectedProgramContext } from '@/Contexts/SelectedProgramContext';
import { QuestionProps } from '@/models/Question';

const AttestationQuestion = ({ question }: { question: QuestionProps }) => {
  ///ADD TERMS AND CONDITIONS
  const [open, setOpen] = useState<boolean>(false);

  const { selectedProgramInfo } = useContext(SelectedProgramContext);
  const { currentApplication } = useContext(CurrentApplicationContext);
  const termsAndConditionsHtml = currentApplication.applicationType?.termsAndConditionsHtml;

  const { translatedText } = useContext(LocaleContext);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box id='termsAndConditions' width={'100%'} margin={'10px auto 10px auto'} textAlign={'center'}>
      <Box flex={1}>
        <Link
          component='button'
          onClick={() => {
            setOpen(true);
          }}
        >
          {question.questionText}
        </Link>
      </Box>
      <Dialog open={open} onClose={handleClose} maxWidth='md'>
        <DialogTitleWithClose onClose={handleClose}>
          {selectedProgramInfo?.programName} {translatedText.signature.terms}
        </DialogTitleWithClose>
        <DialogContent>
          {termsAndConditionsHtml != null && termsAndConditionsHtml.trim() !== '' && (
            <div
              dangerouslySetInnerHTML={{
                __html: termsAndConditionsHtml,
              }}
            ></div>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant='primary' size='large' onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AttestationQuestion;
